import axios from "axios";
import { gapi } from "./api.js";
import str from '../index.js';
const url = gapi + "districts";


const districts = {
  namespaced: true,
  state: {
    msg:null,
    districtsAll: [],
    city:[]
  },
  getters: {
    GET_ALLDATA: (state) => {
      return state.districtsAll;
    },
    getTodoById: (state) => (id) => {
      return state.districtsAll.find((todo) => todo.id == id);
    },
    getMsg: (state) => {
      return state.msg;
    }
  },
  mutations: {
    SET_DATA(state, data) {
      state.districtsAll = data;
    },

    ADD_DATA(state, data) {
      this.city = str.state.cities.find((todo) => todo.id == data.cID);
      data.cName = this.city.cName;
      state.districtsAll.unshift(data);
    },
  
    UPDATE_DATA(state, data) { 
      const index = state.districtsAll.findIndex((t) => t.id === data.id);
      this.city = str.state.cities.find((todo) => todo.id == data.cID);
      var dts = {
        id : data.id ,
        dName: data.dName,
        cID: data.cID,
        cName : this.city.cName
                     }
      if (index !== -1) {
        state.districtsAll.splice(index, 1, dts);
      }
    },
    DELETE_DATA(state, data) {
      state.districtsAll = state.districtsAll.filter((t) => data.id !== t.id);
    },STATE_CRUD(state,data){
      var num = data;
      num = num.toString().replace( /^\D+/g, '');
      state.msg = num;
    }
  }
  ,
  actions: {

    async fetchData({ commit }) {
      await axios
        .get(url,{headers:{Authorization: str.state.token}})
        .then((res) => {
          commit("SET_DATA", res.data.data);
          // console.log(res.data.data)
        })
        .catch((error) => console.log(error));
    }, // get all data view with reletion
  
    // add student
    async addData({ commit }, data) {
      await axios
        .post(url, data,{headers:{Authorization: str.state.token}})
        .then((res) => {
          commit("ADD_DATA", res.data.data);
          return res
        })
        .catch((error) => {
        console.log(error)
        return error
      });
    },
    // get student to edit
    async getData(id) {
      await axios
        .get(url + "/" + id,{headers:{Authorization: str.state.token}})
        .then((res) => {
          return res.data.data;

        })
        .catch((error) => console.log(error));
    },
    // update student
   async  updateData({ commit }, data) {

      var app = url + "/" + data.id;
      await axios
        .put(app, data,{headers:{Authorization: str.state.token}})
        .then((res)=>{
         
          commit("UPDATE_DATA", data)
          commit("STATE_CRUD", res.data.status)
        
        })
        .catch((error) =>{ console.log(error)
         
         
          commit("STATE_CRUD", error)
      });
    
    },

    async deleteData({ commit }, data) {
      var app = url + "/" + data.id;
      await axios
        .delete(app,{headers:{Authorization: str.state.token}})
        .then(
          commit("DELETE_DATA", data)
 
        )
        .catch((error) => console.log(error));
    },
  },
};
export default districts;
